import CssBaseline from '@mui/material/CssBaseline';
import {
  ThemeProvider as MUIThemeProvider,
  StyledEngineProvider,
  type ThemeOptions,
  createTheme,
} from '@mui/material/styles';
import type {} from '@mui/x-date-pickers/themeAugmentation';
import { type ReactNode, useMemo } from 'react';
import breakpoints from './breakpoints';
import componentsOverride from './overrides';
import palette from './palette';
import shadows, { customShadows } from './shadows';
import typography from './typography';

type Props = {
  children: ReactNode;
};

export function ThemeProvider({ children }: Props) {
  // Todo: setup new way to set theme mode
  // const isLight = themeMode === 'light';
  const isLight = true;

  const themeOptions: ThemeOptions = useMemo(
    () => ({
      isDark: !isLight,
      isLight,
      palette: isLight ? palette.light : palette.dark,
      typography,
      breakpoints,
      shape: { borderRadius: 8 },
      shadows: isLight ? shadows.light : shadows.dark,
      customShadows: isLight ? customShadows.light : customShadows.dark,
    }),
    [isLight],
  );

  const theme = createTheme(themeOptions);

  // @ts-expect-error
  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
